import { VolumeOff } from "@lazarentertainment/web-design-system/components/iconOutline"
import { isMobile } from "react-device-detect"
import { FormattedMessage } from "react-intl"

import { useVideoContext } from "./VideoContext"

import styles from "./UnmuteButton.module.css"

export type UnmuteButtonProps = {
  onClick?: () => void
}

export const UnmuteButton = ({ onClick }: UnmuteButtonProps) => {
  const { videoElement, setMutedPreview } = useVideoContext()

  const clickHandler = () => {
    videoElement.muted = false
    setMutedPreview(false)
    onClick?.()
  }

  return (
    <div className={styles.unmuteButtonContainer} onClick={clickHandler}>
      <button
        type="button"
        aria-label="Unmute"
        className={styles.unmuteButton}
        onClick={clickHandler}
      >
        <VolumeOff data-size="2xl" />
      </button>
      <h2
        className={`body-lg text-color-primary-inverse ${styles.unmuteButtonText}`}
      >
        {isMobile ? (
          <FormattedMessage
            id="video.unmuteMobile"
            defaultMessage="Tap to watch"
          />
        ) : (
          <FormattedMessage
            id="video.unmuteDesktop"
            defaultMessage="Click to watch"
          />
        )}
      </h2>
    </div>
  )
}
